import React from 'react';
import clsx from 'clsx';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

import type { TThreadEvent } from 'src/pages/landlord/leads/messages/components/messages-container/thread-events';
import {
    toneClass,
    eventIcon,
    eventTooltip,
} from 'src/pages/landlord/leads/messages/components/messages-container/thread-event-visuals';

import styles from 'src/pages/landlord/leads/messages/components/messages-container/LeadHistoryDivider.module.css';

type Props = {
    event: TThreadEvent;
    time: string;
}

/**
 * Marks a point in the conversation where something changed about the lead — a new property
 * interest, a stage change, a tour outcome. Deliberately built as the same divider the thread
 * already uses for a channel switch, so it reads as punctuation rather than as a message.
 */
export default function LeadHistoryDivider({ event, time }: Props) {
    return (
        <div className={styles.divider} data-testid={`lead-history-${event.key}`}>
            <span className={styles.line} aria-hidden="true" />
            <Tooltip title={eventTooltip(event)}>
                <span className={styles.pill} aria-label={eventTooltip(event)}>
                    <span className={clsx(styles.icon, toneClass(event.tone))} aria-hidden="true">
                        {eventIcon(event)}
                    </span>
                    <Typography
                        variant="caption"
                        component="span"
                        color="inherit"
                        className={styles.label}
                    >
                        {event.label}
                    </Typography>
                    <Typography variant="caption" component="span" className={styles.time}>
                        {time}
                    </Typography>
                </span>
            </Tooltip>
            <span className={styles.line} aria-hidden="true" />
        </div>
    );
}
